import _defineProperty from "/app/web/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _asyncToGenerator from "/app/web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _toConsumableArray from "/app/web/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _regeneratorRuntime from "/app/web/node_modules/@babel/runtime/regenerator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { CloseCircleOutlined, SearchOutlined, UserSwitchOutlined } from '@ant-design/icons';
import { Alert, Button, Input, message, Space } from 'antd';
import { Colors } from 'core/interfaces/variables.types';
import { TaskType } from 'core/modules/tasks/task.interface';
import { getTaskStore } from 'core/modules/tasks/task.store';
import { useTasksPaginationStore } from 'core/modules/tasks/tasks-pagination.store';
import { debounce } from 'core/utils/time';
import { useCallback, useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { TaskStateSelect } from 'src/components/Form/TaskStateSelect';
import { UserSelect } from 'src/components/Form/UserSelect';
import { TasksTable } from 'src/components/Tasks/Table';
import { classes } from 'src/utils/classes';
import styled from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var RoutesTasksUpdateTasksModalNewTasksTable = function RoutesTasksUpdateTasksModalNewTasksTable(_ref) {
  var _initialIds$length;

  var assigneeId = _ref.assigneeId,
      currentTasks = _ref.currentTasks,
      selectedIds = _ref.selectedIds,
      initialIds = _ref.initialIds,
      isValid = _ref.isValid,
      onChange = _ref.onChange;

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var _getTaskStore = getTaskStore(),
      isLoadingKey = _getTaskStore.isLoadingKey,
      repository = _getTaskStore.repository,
      taskById = _getTaskStore.taskById,
      populateTask = _getTaskStore.populateTask,
      updateTask = _getTaskStore.updateTask;

  var pagination = useTasksPaginationStore(repository, {
    types: [TaskType.Report]
  });

  var _useState = useState(''),
      search = _useState[0],
      setSearch = _useState[1];

  var _useState2 = useState([]),
      assignedIds = _useState2[0],
      setAssignedIds = _useState2[1];

  var _useState3 = useState([]),
      states = _useState3[0],
      setStates = _useState3[1];

  var tasks = useMemo(function () {
    var _initialIds$map;

    return [].concat(_toConsumableArray((_initialIds$map = initialIds === null || initialIds === void 0 ? void 0 : initialIds.map(populateTask)) !== null && _initialIds$map !== void 0 ? _initialIds$map : []), _toConsumableArray(pagination.items.filter(function (it) {
      return !currentTasks.includes(it.id) && !(initialIds !== null && initialIds !== void 0 && initialIds.includes(it.id));
    }).map(populateTask)));
  }, [initialIds, currentTasks, pagination.items, populateTask]);

  var reassignTask = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(id) {
      var task;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              task = taskById(id);

              if (task) {
                _context.next = 3;
                break;
              }

              return _context.abrupt("return", message.error(t('unknownError')));

            case 3:
              _context.prev = 3;
              _context.next = 6;
              return updateTask(id, _objectSpread(_objectSpread({}, task), {}, {
                assignedToUserId: assigneeId
              }));

            case 6:
              message.success(t('changesSaved'));
              _context.next = 12;
              break;

            case 9:
              _context.prev = 9;
              _context.t0 = _context["catch"](3);
              message.error(t('unknownError'));

            case 12:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[3, 9]]);
    }));

    return function reassignTask(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  var updateFilters = useCallback(debounce(function (search, assignedIds, states) {
    pagination.setFilters({
      contains: search || undefined,
      assigneeIds: assignedIds !== null && assignedIds !== void 0 && assignedIds.length ? assignedIds : undefined,
      states: states !== null && states !== void 0 && states.length ? states : undefined
    });
  }, 500), []);
  useEffect(function () {
    updateFilters(search, assignedIds, states);
  }, [search, assignedIds, states]);
  useEffect(function () {
    pagination.setActive(true);
  }, []);
  return /*#__PURE__*/_jsxs(Container, {
    children: [/*#__PURE__*/_jsxs(Space, {
      className: "filters",
      children: [/*#__PURE__*/_jsx(SearchInput, {
        type: "search",
        placeholder: t('form.task.content.filter'),
        onInput: debounce(function (ev) {
          return setSearch(ev.target.value);
        }, 500),
        prefix: /*#__PURE__*/_jsx(SearchOutlined, {})
      }, "search"), /*#__PURE__*/_jsx(UserSelect, {
        isMultiple: true,
        allowNone: true,
        allowClear: true,
        placeholder: t('form.task.assignee.filter'),
        emptyMessage: t('form.task.assignee.empty'),
        onChange: debounce(function (value) {
          return setAssignedIds(value);
        }, 500)
      }), /*#__PURE__*/_jsx(TaskStateSelect, {
        isMultiple: true,
        allowClear: true,
        placeholder: t('form.task.state.filter'),
        onChange: debounce(function (value) {
          return setStates(value);
        }, 500)
      })]
    }), /*#__PURE__*/_jsx(TasksTable, {
      isLoading: pagination.isLoading,
      tasks: tasks,
      className: classes({
        invalid: !isValid
      }),
      rowClassName: function rowClassName(row) {
        return row.assignedToUserId !== assigneeId ? 'table-row-invalid' : '';
      },
      visibleColumns: {
        type: true,
        deadline: true,
        company: true,
        reference: true,
        state: true,
        assignee: true,
        reportZone: true,
        reportIsFraud: true
      },
      extraColumns: [{
        key: 'actions',
        fixed: 'right',
        // eslint-disable-next-line react/display-name
        render: function render(row) {
          if (row.assignedToUserId === assigneeId) {
            return null;
          }

          return /*#__PURE__*/_jsxs(Button, {
            size: "small",
            loading: isLoadingKey(row.id),
            onClick: function onClick(ev) {
              ev.stopPropagation();
              ev.preventDefault();
              reassignTask(row.id);
            },
            children: [/*#__PURE__*/_jsx(UserSwitchOutlined, {}), t('route.tasks.rearrange.reassign')]
          });
        }
      }],
      size: "small",
      pagination: {
        position: ['bottomCenter'],
        showSizeChanger: false,
        pageSize: pagination.pageSize + ((_initialIds$length = initialIds === null || initialIds === void 0 ? void 0 : initialIds.length) !== null && _initialIds$length !== void 0 ? _initialIds$length : 0),
        total: pagination.total
      },
      rowSelection: {
        type: 'checkbox',
        selectedRowKeys: selectedIds,
        columnWidth: 32,
        onChange: onChange
      },
      onChange: function onChange(newPagination) {
        pagination.fetchPage(newPagination.current - 1, 10);
      }
    }), !isValid && /*#__PURE__*/_jsx(Alert, {
      type: "error",
      icon: /*#__PURE__*/_jsx(CloseCircleOutlined, {}),
      showIcon: true,
      message: t('route.tasks.rearrange.addMoreReassign')
    })]
  });
}; // Styles

var Container = styled.div.withConfig({
  displayName: "NewTasksTable__Container",
  componentId: "sc-1ntdg4d-0"
})([".ant-table{margin:0 -24px;margin-top:1em;}.ant-table-wrapper.invalid{.ant-table{.ant-table-thead{th{border-color:", ";background-color:#fff2f0;color:", ";}}}}.ant-table{.ant-table-thead th,.ant-table-tbody td{transition:all 0.3s;}.ant-table-row-selected.table-row-invalid{td{border-color:", ";background-color:#fff2f0;}}}.filters .ant-select{width:200px;}"], Colors.danger, Colors.danger, Colors.danger);
var SearchInput = styled(Input).withConfig({
  displayName: "NewTasksTable__SearchInput",
  componentId: "sc-1ntdg4d-1"
})(["max-width:200px;"]);